"use client";

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";

/**
 * 3D-Zeitring & Bodenraster im Hintergrund + gestochen scharfer Cron-Code im Vordergrund.
 */
export default function Preview() {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setStep((s) => (s + 1) % 2), 2500);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      aria-hidden="true"
      className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-2xl p-4 select-none"
      style={{ perspective: "900px" }}
    >
      <motion.div
        animate={{ scale: [1, 1.22, 1], opacity: [0.45, 0.85, 0.45] }}
        transition={{ duration: 4.5, repeat: Infinity }}
        className="pointer-events-none absolute left-1/2 top-1/2 h-40 w-56 -translate-x-1/2 -translate-y-1/2 rounded-full bg-sky-500/30 blur-3xl"
      />

      <div
        className="pointer-events-none absolute inset-x-[-20%] bottom-[-35%] h-[110%] opacity-45 dark:opacity-60"
        style={{
          transform: "rotateX(68deg)",
          maskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 65% 55% at 50% 50%, black 25%, transparent 80%)",
        }}
      >
        <motion.div
          animate={{ backgroundPosition: ["0px 0px", "0px 28px"] }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="h-full w-full bg-[linear-gradient(to_right,rgba(14,165,233,0.3)_1px,transparent_1px),linear-gradient(to_bottom,rgba(14,165,233,0.3)_1px,transparent_1px)] bg-[size:28px_28px]"
        />
      </div>

      {/* 3D-Zeitring im Hintergrund */}
      <motion.div
        animate={{ rotateZ: 360 }}
        transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
        style={{ transform: "rotateX(55deg)" }}
        className="pointer-events-none absolute h-36 w-36 rounded-full border-2 border-dashed border-sky-400/55 shadow-[0_0_24px_rgba(14,165,233,0.3)]"
      />

      {/* Gestochen scharfer Vordergrund */}
      <div className="relative z-10 flex flex-col items-center gap-2.5 antialiased">
        <div className="flex items-center gap-2 rounded-xl border border-sky-400/70 bg-white px-3.5 py-1.5 font-mono text-xs font-black tracking-wider text-sky-600 shadow-[0_12px_24px_-4px_rgba(14,165,233,0.45)] dark:bg-zinc-900 dark:text-sky-300">
          <Clock className="h-3.5 w-3.5 text-sky-500" />
          <span>15 8 * * 1-5</span>
        </div>

        <motion.div
          animate={{ y: step === 1 ? -3 : 2 }}
          transition={{ type: "spring", stiffness: 280, damping: 20 }}
          className="flex items-center gap-2 rounded-2xl border border-emerald-400/80 bg-white px-4 py-2 shadow-[0_16px_32px_-4px_rgba(16,185,129,0.5)] dark:bg-zinc-900"
        >
          <span className="h-2 w-2 rounded-full bg-emerald-500 shadow-[0_0_8px_#10b981]" />
          <span className="font-sans text-xs font-black text-neutral-900 dark:text-white">
            Mo–Fr um 08:15 Uhr
          </span>
        </motion.div>
      </div>
    </div>
  );
}
